import React from "react";
import Modal from "../../../components/Modal";
import Input from "../../../components/Input";
import { convertIntToMoney } from "../../../helpers/conversions";
import { getSomarcasEngravingPrice, hasSomarcasEngraving } from "./somarcasEngraving";

/**
 * Faixas de preço que o fornecedor informou para a variação, só para consulta,
 * no mesmo formato da tabela de preços do produto.
 *
 * Na Só Marcas o preço do produto quase não muda entre as faixas: o que muda é
 * a gravação. O preço com gravação mostra essa variação (BDM-1303).
 */
export const ModalAvailablePrices = ({ show, close, prices, quantity, product }) => {
    const sorted = [...(prices ?? [])].sort((a, b) => a.init_quantity - b.init_quantity);

    const covers = price => quantity >= price.init_quantity && quantity <= price.final_quantity;

    const showEngraving = hasSomarcasEngraving(product);

    const priceWithEngraving = price => {
        const engraving = getSomarcasEngravingPrice(product, price.init_quantity);

        return engraving.found ? price.price + engraving.price : null;
    };

    return (
        <Modal
            className="modal--available-prices"
            title={`Preços disponíveis`}
            size={showEngraving ? 'big' : undefined}
            show={show}
            close={close}
        >
            {sorted.map((price, index) => {
                const withEngraving = showEngraving ? priceWithEngraving(price) : null;

                return (
                    <div className="section" key={index}>
                        <div className="row">
                            <div className="col">
                                <Input label={`Quant. inicial`} value={price.init_quantity} disabled={true} highlighted={covers(price)} />
                            </div>
                            <div className="col">
                                <Input label={`Quant. final`} value={price.final_quantity} disabled={true} highlighted={covers(price)} />
                            </div>
                            <div className="col">
                                <Input label={`Preço`} value={`R$ ${convertIntToMoney(price.price)}`} disabled={true} highlighted={covers(price)} />
                            </div>
                            {withEngraving !== null &&
                                <div className="col">
                                    <Input label={`Preço com gravação`} value={`R$ ${convertIntToMoney(withEngraving)}`} disabled={true} highlighted={covers(price)} />
                                </div>
                            }
                        </div>
                    </div>
                );
            })}
        </Modal>
    );
};

export default ModalAvailablePrices;
